import {
  Directive,
  ElementRef,
  Input,
  AfterViewInit,
  OnChanges
} from '@angular/core';
import { environment } from '@env/environment';

@Directive({
  selector: '[setImage]'
})
export class SetImageDirective implements AfterViewInit, OnChanges {
  private el: HTMLElement;
  baseUrl = environment.baseUrl;
  backgroundImage: string;

  constructor(el: ElementRef) {
    this.el = el.nativeElement;
  }

  @Input()
  set setImage(image) {
    this.backgroundImage = image;
  }

  ngAfterViewInit() {
    this.setBackground();
  }

  ngOnChanges(image) {
    if (image.setImage) {
      this.backgroundImage = image.setImage.currentValue;
      this.setBackground();
    }
  }

  setBackground() {
    this.el.style.background =
      'url(' +
      this.baseUrl.concat(this.backgroundImage) +
      ') center center no-repeat';
  }
}
